export const ANIMATION = {
    DURATION_MS: 320,
    EASING: 'cubic-bezier(0.4, 0, 0.2, 1)',
    FILL: 'both',
};

export const DEFAULTS = {
    LINES: 5,
};

export const MEASURE = {
    SCROLL_OVERFLOW_EPSILON_PX: 1,
    LINE_HEIGHT_TO_FONT_RATIO: 1.2,
};
